import { inject } from 'vue';
export function useApi() {
    const apiBaseUrl = inject('apiBaseUrl', '');
    if (!apiBaseUrl) {
        console.warn('apiBaseUrl not provided');
    }
    return {
        apiBaseUrl
    };
}
